import React from 'react'
import Main from '../components/Main';


function Project() {
  return (
    <div className="projects mt-5 ">
      <Main />
      </div>
  )
}

export default Project;